import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledRequestGreenCardSuccess = styled.div`
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    padding-top: 50px;
    padding-bottom: 50px;
    margin-bottom: 20px;
    text-align: center;
    @media ${breakpoints.mdMax} {
        height: 95%;
        padding-top: 0;
    }
    .requestInfo {
        max-width: 300px;
        margin: 0 auto;
        svg {
            @media ${breakpoints.mdMax} {
                max-height: 110px;
            }
        }
    }
    .successImage {
        margin-bottom: 24px;
        border-radius: var(--radius-5);
        @media ${breakpoints.mdMax} {
            margin-bottom: 5px;
        }
    }
    .successDialogText {
        font-size: var(--size-16);
        line-height: 20px;
        color: var(--color-grey-900);
        text-align: center;
    }
    .btnWrapper {
        position: absolute;
        bottom: 0;
        width: 100%;
    }
`;
